<template>
    <div>
        <el-row :gutter="8">
          <el-col :span="8" v-for="(item,index) in voices" :key="index" class="voiceColumn">
            <el-card :body-style="{ padding: '0px' }"
            @mouseleave.native="mouseLeave(index)"
            @mouseover.native="mouseOver(index)"
            id="card">
              <div slot="header">
                <i class="el-icon-microphone" :style='item.color'></i>
                {{item.name}}
              </div>
              <div>
                <p v-for="(subItem,subIndex) in item.displayContent" :key="subIndex">{{subItem}}</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
  data: function () {
    return {
    }
  },
  computed: {
    voices () {
      const items = this.$t('voc.voices') || []
      return items.map(item => Object.assign({}, item, {
        displayContent: (item.subTitle || []).slice()
      }))
    }
  },
  methods: {
    mouseOver (index) {
      this.voices[index].displayContent = this.voices[index].voice
    },
    mouseLeave (index) {
      this.voices[index].displayContent = this.voices[index].subTitle
    }
  }
}
</script>

<style scoped>
.voiceColumn {
    margin-bottom: 20px;
}

#card {
     /* width:180px; */
    height:180px;
    /* background:gold; */
    /* transition:height 2s; */
    /* -webkit-transition:height 2s;  */
    padding: 10px;
}

#card:hover
{
    height:auto;
}
</style>
